import apolloClient from '../apollo-client'
import TRACK_MEDIA_END from './mutations/track-media-end.graphql'
import TRACK_MEDIA_PAUSE from './mutations/track-media-pause.graphql'
import TRACK_MEDIA_PLAY from './mutations/track-media-play.graphql'
import TRACK_MEDIA_SEEK from './mutations/track-media-seek.graphql'
import TRACK_MEDIA_VOLUME_CHANGE from './mutations/track-media-volume-change.graphql'

function getDataFromElement(element: HTMLMediaElement): string {
  const data = {
    currentTime: element.currentTime,
    duration: element.duration,
    ended: element.ended,
    muted: element.muted,
    paused: element.paused,
    volume: element.volume,
  }

  return JSON.stringify(data)
}

export const onPlay = (id: string, element: HTMLMediaElement) =>
  apolloClient.mutate({
    mutation: TRACK_MEDIA_PLAY,
    variables: {
      id,
      data: getDataFromElement(element),
    },
  })

export const onPause = (id: string, element: HTMLMediaElement) =>
  apolloClient.mutate({
    mutation: TRACK_MEDIA_PAUSE,
    variables: {
      id,
      data: getDataFromElement(element),
    },
  })

export const onEnded = (id: string, element: HTMLMediaElement) =>
  apolloClient.mutate({
    mutation: TRACK_MEDIA_END,
    variables: {
      id,
      data: getDataFromElement(element),
    },
  })

export const onSeeked = (id: string, element: HTMLMediaElement) =>
  apolloClient.mutate({
    mutation: TRACK_MEDIA_SEEK,
    variables: {
      id,
      data: getDataFromElement(element),
    },
  })

export const onVolumeChange = (id: string, element: HTMLMediaElement) =>
  apolloClient.mutate({
    mutation: TRACK_MEDIA_VOLUME_CHANGE,
    variables: {
      id,
      data: getDataFromElement(element),
    },
  })

export const getTrackingProps = (
  id: string,
  userId?: string | null,
  auxFunctionOnEnd?: Function,
  auxFunctionOnPlay?: Function,
  auxFunctionOnInteraction?: Function
) => {
  if (userId === null) return {}

  return {
    onEnded: (event) => {
      auxFunctionOnEnd?.(true)
      onEnded(id, event.target as HTMLMediaElement)
    },
    onPause: (event) => {
      auxFunctionOnInteraction?.('pause')
      onPause(id, event.target as HTMLMediaElement)
    },
    onPlay: (event) => {
      auxFunctionOnPlay?.()
      auxFunctionOnInteraction?.('play')
      onPlay(id, event.target as HTMLMediaElement)
    },
    onSeeked: (event) => {
      auxFunctionOnInteraction?.('seeked')
      onSeeked(id, event.target as HTMLMediaElement)
    },
    onVolumeChange: (event) => {
      if (event.target.muted) {
        auxFunctionOnInteraction?.('muted')
      } else {
        auxFunctionOnInteraction?.('volumechange')
      }

      onVolumeChange(id, event.target as HTMLMediaElement)
    },
    onRateChange: () => {
      auxFunctionOnInteraction?.('ratechange')
    },
  }
}
